import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import RequestQuoteFormContext from "./RequestQuoteFormContext";
import { Col, Row } from "react-bootstrap";
const Details = () => {
	const { details, setDetails, next } = useContext(RequestQuoteFormContext);
	const [fromOptions, setFromOptions] = useState([]);
	const [toOptions, setToOptions] = useState([]);

	const fetchPredictions = (input, field) => {
		if (window.google && window.google.maps) {
			const service = new window.google.maps.places.AutocompleteService();
			service.getPlacePredictions({ input: input }, (predictions) => {
				const mapped = (predictions || []).map((p, index) => ({
					value: index + 1, // or p.description if you prefer
					label: p.description, // what you show in the dropdown
				}));
				const userInputOption = {
					value: 0,
					label: input,
				};
				if (field === "from") {
					setFromOptions([userInputOption, ...mapped]);
				} else if (field === "to") {
					setToOptions([userInputOption, ...mapped]);
				}
			});
		}
	};

	useEffect(() => {
		fetchPredictions("", "from");
		fetchPredictions("", "to");
	}, []);

	const handleChange = (first, second) => {
		if (second && second.name) {
			setDetails((prev) => ({
				...prev,
				[second.name]: first,
			}));
			setFromOptions([])
			setToOptions([])
		} else if (first?.target) {
			const { name, value } = first.target;
			setDetails((prev) => ({ ...prev, [name]: value }));
		}
	};

	const handleInputChange = (fieldName) => (inputValue) => {
		if (inputValue) {
			fetchPredictions(inputValue, fieldName);
		}
	};

	const [errors, setErrors] = useState({});

	const handleSubmit = (e) => {
		e.preventDefault();
		const newErrors = {};

		if (
			!details.from ||
			typeof details.from !== "object" ||
			!details.from.label
		)
			newErrors.from = "From is required.";
		if (!details.to || typeof details.to !== "object" || !details.to.label)
			newErrors.to = "To is required.";
		if (
			!details.quantity ||
			isNaN(details.quantity) ||
			parseInt(details.quantity) <= 0
		)
			newErrors.quantity = "Quantity must be a positive integer.";
		if (
			!details.weight ||
			isNaN(details.weight) ||
			parseFloat(details.weight) <= 0
		)
			newErrors.weight = "Weight must be a positive number.";
		if (
			!details.length1 ||
			isNaN(details.length1) ||
			parseFloat(details.length1) <= 0
		)
			newErrors.length1 = "Length must be a positive number.";
		if (
			!details.width ||
			isNaN(details.width) ||
			parseFloat(details.width) <= 0
		)
			newErrors.width = "Width must be a positive number.";
		if (
			!details.height ||
			isNaN(details.height) ||
			parseFloat(details.height) <= 0
		)
			newErrors.height = "Height must be a positive number.";
		if (!details.description || details.description.trim() === "")
			newErrors.description = "Description is required.";

		setErrors(newErrors);

		if (Object.keys(newErrors).length > 0) {
			return;
		}

		next();
	};

	return (
		<form className="quote-form">
			<Row className="g-3">
				<Col xs={12} md={6} lg={6}>
					<div className="contact-input d-flex flex-column ">
						<span>From</span>
						<Select
							required
							defaultValue="AE"
							className="basic-single"
							classNamePrefix="select"
							placeholder="Enter a location or address"
							isSearchable
							name="from"
							value={details.from}
							onChange={handleChange}
							onInputChange={handleInputChange('from')}
							options={fromOptions}
							theme={(theme) => ({
								...theme,
								borderRadius: 0,
								colors: {
									...theme.colors,
									primary25: "#a0e3ffff",
									primary: "#2abaf7",
								},
							})}
						/>
						<span className="text-danger">{errors && errors.from}</span>
					</div>
				</Col>
				<Col xs={12} md={6} lg={6}>
					<div className="contact-input d-flex flex-column ">
						<span>To</span>
						<Select
							required
							defaultValue="US"
							className="basic-single"
							classNamePrefix="select"
							placeholder="Enter a location or address"
							isSearchable
							name="to"
							value={details.to}
							onChange={handleChange}
							onInputChange={handleInputChange('to')}
							options={toOptions}
							theme={(theme) => ({
								...theme,
								borderRadius: 0,
								colors: {
									...theme.colors,
									primary25: "#a0e3ffff",
									primary: "#2abaf7",
								},
							})}
						/>
						<span className="text-danger">{errors && errors.to}</span>
					</div>
				</Col>
			</Row>
			<Row className="g-3">
				<Col xs={6} md={6} lg={6}>
					<div className="contact-input d-flex flex-column ">
						<span>Quantity</span>
						<input
							type="text"
							value={details.quantity}
							onChange={handleChange}
							name="quantity"
							required
						/>
						<span className="text-danger">{errors && errors.quantity}</span>
					</div>
				</Col>
				<Col xs={6} md={6} lg={6}>
					<div className="contact-input d-flex flex-column ">
						<span>Weight</span>
						<input
							type="text"
							value={details.weight}
							onChange={handleChange}
							name="weight"
							required
						/>
						<span className="text-danger">{errors && errors.weight}</span>
					</div>
				</Col>
			</Row>
			<Row className="g-3">
				<Col xs={4} md={4} lg={4}>
					<div className="contact-input d-flex flex-column ">
						<span>Height {"(cm)"}</span>
						<input
							type="text"
							value={details.height}
							onChange={handleChange}
							name="height"
							required
						/>
						<span className="text-danger">{errors && errors.height}</span>
					</div>
				</Col>
				<Col xs={4} md={4} lg={4}>
					<div className="contact-input d-flex flex-column ">
						<span>Width {"(cm)"}</span>
						<input
							type="text"
							value={details.width}
							onChange={handleChange}
							name="width"
							required
						/>
						<span className="text-danger">{errors && errors.width}</span>
					</div>
				</Col>
				<Col xs={4} md={4} lg={4}>
					<div className="contact-input d-flex flex-column ">
						<span>Length {"(cm)"}</span>
						<input
							type="text"
							value={details.length1}
							onChange={handleChange}
							name="length1"
							required
						/>
						<span className="text-danger">{errors && errors.length1}</span>
					</div>
				</Col>
			</Row>
			<Row className="g-3">
				<Col xs={12} md={12} lg={12}>
					<div className="contact-input d-flex flex-column ">
						<span>What are you sending?</span>
						<textarea
							rows={4}
							value={details.description}
							onChange={handleChange}
							name="description"
							required
						></textarea>
						<span className="text-danger">{errors && errors.description}</span>
					</div>
				</Col>
			</Row>
			<button onClick={handleSubmit} className="btn mt-3">
				Next
			</button>
		</form>
	);
};
export default Details;
